import { render, staticRenderFns } from "./toDoStatistics.vue?vue&type=template&id=8156d802&scoped=true"
import script from "./toDoStatistics.vue?vue&type=script&lang=js"
export * from "./toDoStatistics.vue?vue&type=script&lang=js"
import style0 from "./toDoStatistics.vue?vue&type=style&index=0&id=8156d802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8156d802",
  null
  
)

export default component.exports